<button class="back-button" (click)="onClick()" [attr.aria-label]="'shared.buttons.backButton.label' | i18n">
  <mat-icon>arrow_back</mat-icon>
  <span>{{ 'shared.buttons.backButton.label' | i18n }}</span>
</button>
